<template>
  <section>
  <div class="t-headline10 mgt-50 pdt-6 mgb-16 font-m t-color-headline-black">{{ $t('30066') }}</div>
  <div v-if="missionsList" class="mdc-card mgb-24">
    <div class="mdc-card__primary-action1" tabindex="0">
      <div v-for="(mission, index) in missionsList" :key="index" >
        <div v-for="(assignment, index) in mission.assignments" :key="index" class="d-flex pdt-16 mgl-24 my-course-list position-relative min-h-auto learn-missionCard" tabindex="0">
          <div class="list-image-small40">
            <img alt="" class="w-40 h-40" src="../../../images/misson.svg">
          </div>
          <div class="flex-grow-1 pdl-20">
            <div class="mgb-16">
              <div class="d-flex justify-content-between align-items-center pdr-24">
                <div class="t-body1 font-r pdr-24 l-spacing48 pdb-4">
                  {{ assignment.name }}
                </div>
              </div>

              <div class="d-flex justify-content-between align-items-center pdr-24">
                <div class="d-flex justify-content-between">
                  <div class="t-body6 t-color-bodyGrayA font-r t-line-h-22 l-spacing42 mgr-8">{{ $t('30212') }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="missionsList.length > index + 1" class="divider"></div>
      </div>
    </div>
  </div>
  </section>
</template>

<script>
import microCourseApi from "@/api/microCourseApi";

export default {
  name: "Mission",

  props: ['missionsList'],

}
</script>

<style scoped>

</style>
